var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContainer"},[_c('h1',[_vm._v("All Users")]),_c('all-users',{attrs:{"id":"allUsers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }